import type { TFunction } from "i18next";
import {
  ORG_NAME_MAX_LENGTH,
  ORG_NAME_MIN_LENGTH,
  ROLE_DESCRIPTION_MAX_LENGTH,
  ROLE_NAME_MAX_LENGTH,
  ROLE_NAME_MIN_LENGTH,
  checkOrgName,
  checkRoleName,
  isRoleDescriptionTooLong,
} from "@nexus/contracts";

/** Inline error for a role name, or `null` when the API will accept it. */
export function roleNameError(t: TFunction, name: string): string | null {
  switch (checkRoleName(name)) {
    case "required":
      return t("iam.validation.roleNameRequired", "Role name is required");
    case "tooShort":
      return t("iam.validation.roleNameTooShort", "Role name must be at least {{min}} characters", {
        min: ROLE_NAME_MIN_LENGTH,
      });
    case "tooLong":
      return t("iam.validation.roleNameTooLong", "Role name must be {{max}} characters or fewer", {
        max: ROLE_NAME_MAX_LENGTH,
      });
    case "noLetter":
      return t("iam.validation.roleNameNoLetter", "Include at least one letter. Names made only of emoji or numbers can't be searched or read aloud.");
    case "markup":
      return t("iam.validation.roleNameMarkup", "Role name cannot contain < or >");
    default:
      return null;
  }
}

/** Inline error for a role description, or `null` when it fits the column. */
export function roleDescriptionError(t: TFunction, description: string): string | null {
  if (!isRoleDescriptionTooLong(description)) return null;
  return t("iam.validation.roleDescriptionTooLong", "Description must be {{max}} characters or fewer", {
    max: ROLE_DESCRIPTION_MAX_LENGTH,
  });
}

/** Inline error for a new organization name, or `null` when the API will accept it. */
export function orgNameError(t: TFunction, name: string): string | null {
  switch (checkOrgName(name)) {
    case "required":
      return t("iam.validation.orgNameRequired", "Organization name is required");
    case "tooShort":
      return t("iam.validation.orgNameTooShort", "Organization name must be at least {{min}} characters", {
        min: ORG_NAME_MIN_LENGTH,
      });
    case "tooLong":
      return t("iam.validation.orgNameTooLong", "Organization name must be {{max}} characters or fewer", {
        max: ORG_NAME_MAX_LENGTH,
      });
    case "noLetter":
      return t("iam.validation.roleNameNoLetter", "Include at least one letter. Names made only of emoji or numbers can't be searched or read aloud.");
    case "markup":
      return t("iam.validation.orgNameMarkup", "Organization name cannot contain < or >");
    default:
      return null;
  }
}
